export default "__VITE_ASSET__BStPC8nP__"